import { cva } from "class-variance-authority";

/**
 * Size variants for the Split Button components.
 * These map to the MD3 Expressive container heights.
 */
const splitButtonSizeVariants = {
	xs: "h-[32px] min-h-[32px]",
	sm: "h-[40px] min-h-[40px]",
	md: "h-[56px] min-h-[56px]",
	lg: "h-[96px] min-h-[96px]",
	xl: "h-[136px] min-h-[136px]",
};

/**
 * Color variants for the Split Button components using CVA.
 */
export const splitButtonVariants = cva(
	"group relative w-fit shrink-0 inline-flex flex-row items-center justify-center whitespace-nowrap select-none cursor-pointer transition-[background-color,color,border-color,box-shadow,opacity,filter] duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-m3-primary z-10 overflow-hidden",
	{
		variants: {
			variant: {
				filled: "bg-m3-primary text-m3-on-primary",
				tonal: "bg-m3-secondary-container text-m3-on-secondary-container",
				elevated:
					"bg-m3-surface-container-low text-m3-primary shadow-md hover:shadow-lg",
				outlined: "bg-transparent text-m3-primary border border-m3-outline",
			},
			size: splitButtonSizeVariants,
			disabled: {
				true: "pointer-events-none",
				false: "",
			},
		},
		compoundVariants: [
			{
				variant: "filled",
				disabled: true,
				className: "bg-m3-on-surface/10 text-m3-on-surface/[0.38]",
			},
			{
				variant: "tonal",
				disabled: true,
				className: "bg-m3-on-surface/10 text-m3-on-surface/[0.38]",
			},
			{
				variant: "elevated",
				disabled: true,
				className: "bg-m3-on-surface/10 text-m3-on-surface/[0.38] shadow-none",
			},
			{
				variant: "outlined",
				disabled: true,
				className: "text-m3-on-surface/[0.38] border-m3-on-surface/[0.12]",
			},
		],
		defaultVariants: {
			variant: "filled",
			size: "sm",
			disabled: false,
		},
	},
);
